import { AxiosError, AxiosResponse } from 'axios';
import { UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { ErrorMessage, Profile, ProfileUpdateLoginEnabled } from 'types';
import { client } from 'utils/api-client';

export default function useProfileUpdateLoginEnabled(): UseMutationResult<
  AxiosResponse<Profile>,
  AxiosError<ErrorMessage>,
  ProfileUpdateLoginEnabled
> {
  const queryClient = useQueryClient();

  const mutationFn = (payload: ProfileUpdateLoginEnabled): Promise<AxiosResponse<Profile>> => {
    return client.put(`profiles/${payload.profileId}/login-enabled/`, payload);
  };

  return useMutation(mutationFn, {
    onSuccess: () => {
      queryClient.invalidateQueries(['athletes']);
      queryClient.invalidateQueries(['staff']);
    },
  });
}
